import { render, staticRenderFns } from "./SpaceChallengeRewardModal.vue?vue&type=template&id=3c5dbf26&scoped=true"
import script from "./SpaceChallengeRewardModal.vue?vue&type=script&lang=js"
export * from "./SpaceChallengeRewardModal.vue?vue&type=script&lang=js"
import style0 from "./SpaceChallengeRewardModal.vue?vue&type=style&index=0&id=3c5dbf26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5dbf26",
  null
  
)

export default component.exports